// src/client/components/Card.tsx
import type { HTMLAttributes, ReactNode } from 'react';
import styles from './Card.module.css';

interface Props extends Omit<HTMLAttributes<HTMLDivElement>, 'title'> {
  title?: ReactNode;
  actions?: ReactNode;
  padded?: boolean;
}

export default function Card({ title, actions, padded = true, children, className, ...rest }: Props) {
  const cls = [styles.card, padded && styles.padded, className].filter(Boolean).join(' ');
  return (
    <div {...rest} className={cls}>
      {(title || actions) && (
        <div className={styles.header}>
          <div className={styles.title}>{title}</div>
          {actions && <div className={styles.actions}>{actions}</div>}
        </div>
      )}
      <div className={styles.body}>{children}</div>
    </div>
  );
}
